<template>
    <div class="app-footer">
        <p>Copyright © 2020. All Rights Reserved.</p>
        <p>京ICP备17017235号</p>
        <p class="app-footer__contact">
            <app-button href="mailto:hirozhuz@gmail.com">
                <app-icon value="icon-email"/>
            </app-button>
            <app-button href="https://github.com/hirozhuz"
                        target="_blank"
            >
                <app-icon value="icon-git"/>
            </app-button>
            <app-button href="https://juejin.im/user/2735240658563214"
                        target="_blank"
            >
                <app-icon value="icon-juejin"/>
            </app-button>
        </p>
    </div>
</template>

<script>
    import AppButton from '@components/AppButton'
    import AppIcon from '@components/AppIcon'
    export default {
        name: "AppFooter",
        components:{
            AppButton,
            AppIcon
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";

    .app-footer {
        padding: $paddingMD;

        p {
            font-size: $fontSizeSM;
            text-align: center;
            margin-bottom: $paddingBase;
            color: $textColor;
            color: var(--textColor);
        }
        &__contact{
            margin-top: $paddingMD;
           .app-button:not(:last-child){
               margin-right: $paddingMD;
           }
        }
    }
</style>